import Calendly from "../components/Calendly";
import "./Contact.css"

const Contact = () =>
{
     /*const [form, setForm] = useState({
        firstName: "",
        lastName: "",
        email: "",
        subject: "",
        message: ""
    });

    const handleChange = (e) => {
        setForm({
        ...form,
        [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
        const response = await fetch("http://localhost:5000/api/contact", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(form)
        });

        if (!response.ok) throw new Error("Failed to send");

        alert("Message sent successfully");
        setForm({
            firstName: "",
            lastName: "",
            email: "",
            subject: "",
            message: ""
        });

        } catch (error) {
        console.error(error);
        alert("Something went wrong");
        }
    };*/
    return(
        <section className="contact-section" id="contact">
            <div className="calendar-container">
                <Calendly url="https://calendly.com/drecook16/30min?month=2026-03" height="900px" />
            </div>
        </section>
    );
}
export default Contact;
